import {
    type CuratedStory,
    type VariationComponent,
    isCuratedStory,
} from "~types/types";
import { filterForStoriesWithAudio } from "~utils/filterForStoriesWithAudio";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const curatedStories = items?.filter((item) => isCuratedStory(item));
    const storiesWithAudio = filterForStoriesWithAudio(
        curatedStories as CuratedStory[]
    );
    const messages = checkItemArrayIntegrity(storiesWithAudio);

    return messages;
}
